module.exports = __webpack_public_path__ + "assets/img/qrcode-57266e75.png";